import { SMSDraftService } from '@weave/schema-gen-ts/dist/schemas/sms/draft/v1/draft_service.pb';
import { bindHTTP } from '@frontend/schema';
export const SchemaSMSDraftService = bindHTTP(SMSDraftService);
